// extracted by mini-css-extract-plugin
export default {"error":"styles_error__nk8Uf","discription":"styles_discription__OT0yN"};